export const fabrics = (state = [], action) => {
  if (action.type === 'FETCH_FABRICS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_FABRICS') {
    return [];
  }
  return state;
};

export const fabric = (state = {}, action) => {
  if (action.type === 'FETCH_FABRIC') {
    return action.payload;
  }
  if (action.type === 'CLEAR_FABRIC') {
    return {};
  }
  return state;
};
